import api from '../config/api';
import { to } from '../utils/async';

const KRService = {
  fetchMultipleKrCommentCount: async (krIds) => {
    if (!krIds || !krIds.length) return {};
    const uniqueKrIds = Array.from(new Set(krIds)).sort();
    if (!uniqueKrIds.length) return {};

    const URL = `${wbConfig.baseUrl}/vnext/okr/keyResults/comments/count`;
    const params = {
      krIds: uniqueKrIds.join(','),
    }

  try {
    const [err, response] = await to(api.get(URL, { params }));
    if (err) {
      console.error('Error fetching Key Results Comments by User ID', err);
      return [err, null];
    }

    return response.data;
    } catch (error) {
      console.error('Error fetching Key Results Comments by User ID', error);
      toastr.error('Error fetching Key Results Comments by User ID');
    }
  },
}

export default KRService;
